import styled from 'styled-components'
import { Button } from '../Button'
import {
  getTypographyIntent,
  typographyWeights,
} from '../Typography/Typography.styles'
import { borderRadius } from '../_styles/borderRadius'
import { colors } from '../_styles/colors'
import { getShadow } from '../_styles/shadows'
import { spacing } from '../_styles/spacing'
import type { ToastVariant } from './Toast.types'

export const StyledToast = styled.div<{ $variant: ToastVariant }>`
  ${getShadow(4, 'bottom')}

  align-items: center;
  background-color: ${({ $variant }) =>
    $variant === 'success' ? colors.green30 : colors.red50};
  border-radius: ${borderRadius.md}px;
  box-sizing: border-box;
  color: ${colors.white};
  display: flex;
  flex-wrap: wrap;
  max-width: min(550px, calc(100vw - ${spacing.lg}px));
  min-height: 48px;
  padding: ${spacing.md}px ${spacing.xl}px;
  width: 550px;

  a {
    color: ${colors.white};
    text-decoration: underline;
  }
`

// $legacy is direct string inside Toast. Next is with subcomponents
export const StyledToastText = styled.span<{ $legacy?: boolean }>`
  ${getTypographyIntent('body')}
  flex: 1 1 0;
  font-weight: ${typographyWeights.semibold};
  min-width: 0;
  overflow-wrap: anywhere;

  ${({ $legacy }) =>
    $legacy ? `margin-left: ${spacing.lg}px;` : `padding: 0 ${spacing.lg}px;`}

  @media (max-width: 320px) {
    flex: 0 0 100%;
    order: 1;
    padding: ${spacing.md}px 0 0;

    ${({ $legacy }) => $legacy && 'margin-left: 0;'}
  }
`

export const StyledToastButton = styled(Button)`
  align-self: flex-start;
  line-height: 0;
  color: ${colors.white};
  flex-shrink: 0;
  padding: 0;
  margin-left: auto;
`
